export default "__VITE_ASSET__DzuLyrDc__"